import { useShallow } from 'zustand/react/shallow';
import { useOnboardingStore } from '../onboardingStore';
import { useOnboarding } from '../hooks/useOnboarding';
import { useContextualHint } from '../hooks/useContextualHint';
import { WelcomeModal } from './WelcomeModal';
import { GuidedTour } from './GuidedTour';
import { ContextualHintRenderer } from './ContextualHint';

/**
 * Top-level onboarding orchestration component.
 * Renders in Layout.tsx after all other overlays.
 * Gates rendering of welcome modal, guided tour, and contextual hints.
 */
export function OnboardingProvider() {
  // Initialize onboarding triggers
  useOnboarding();
  useContextualHint();

  const { isWelcomeOpen, activeTour, activeHint } = useOnboardingStore(
    useShallow((s) => ({
      isWelcomeOpen: s.isWelcomeOpen,
      activeTour: s.activeTour,
      activeHint: s.activeHint,
    }))
  );

  return (
    <>
      {isWelcomeOpen && <WelcomeModal />}
      {activeTour && <GuidedTour tourId={activeTour} />}
      {activeHint && <ContextualHintRenderer />}
    </>
  );
}
